import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ScheduleLocation } from './location_builder';

export class ScheduleSectionTime implements IIndexable {
  id: number;
  nk: string;
  cd: string;
  section: number;
  day_of_week: number;
  from_tm: moment.Moment | string;
  to_tm: moment.Moment | string;
  location: number;
  _location: ScheduleLocation;

  constructor(sectionTime: Partial<ScheduleSectionTime>) {
    // This is a _HACK_ to solve for some bad data feeds that are setting what should be 8
    // to 0 instead. Also, this is intentionally made all encompassing outside of [1-7]
    // to prevent this issue from happening again.
    if ((sectionTime.day_of_week as number) > 7 || (sectionTime.day_of_week as number) < 1) {
      sectionTime.day_of_week = 8;
    }
    _4.merge(this, sectionTime);
  }

  static build(sectionTime: Partial<ScheduleSectionTime>): ScheduleSectionTime {
    return new ScheduleSectionTime(sectionTime);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/builders/section_time_builder.ts